(() => {
  const root = document.querySelector('[data-loomforma-announcement-bar]');
  if (!root) return;

  const items = [...root.querySelectorAll('[data-announcement-item]')];
  const prevButton = root.querySelector('[data-announcement-prev]');
  const nextButton = root.querySelector('[data-announcement-next]');
  const bar = root.querySelector('.loomforma-announcement-bar');
  const autoRotate = root.dataset.autoRotate === 'true';
  const rotateSpeed = Number(root.dataset.rotateSpeed) || 5000;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let currentIndex = 0;
  let timerId = null;

  const syncHeight = () => {
    const height = bar ? `${bar.offsetHeight}px` : '36px';
    document.documentElement.style.setProperty('--loomforma-announcement-height', height);
  };

  const showItem = (index) => {
    if (!items.length) return;
    items.forEach((item, itemIndex) => {
      item.classList.toggle('is-active', itemIndex === index);
    });
  };

  const startRotation = () => {
    if (!autoRotate || prefersReducedMotion || items.length < 2) return;
    window.clearInterval(timerId);
    timerId = window.setInterval(() => {
      currentIndex = (currentIndex + 1) % items.length;
      showItem(currentIndex);
    }, rotateSpeed);
  };

  const step = (direction) => {
    if (items.length < 2) return;
    currentIndex = (currentIndex + direction + items.length) % items.length;
    showItem(currentIndex);
    startRotation();
  };

  prevButton?.addEventListener('click', () => step(-1));
  nextButton?.addEventListener('click', () => step(1));
  window.addEventListener('resize', syncHeight, { passive: true });

  showItem(currentIndex);
  syncHeight();
  startRotation();
})();
